<ng-template #modal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h1 class="modal-title">{{ modalTitle }}</h1>
    <span (click)="closeModal()" role="button" class="ms-auto">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>
  <div class="modal-body" [ngClass]="modalBodyClass ? modalBodyClass : null">
    <ng-container #dynamicComponentRef></ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-h45" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary btn-h45" (click)="saveFunction()">{{ modalFooterButtonText }}</button>
  </div>
</ng-template>
